/** lot DJ — heures en heure de Paris, formulations courtes. */
const PARIS = 'Europe/Paris';
const JOURS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];

const aParis = (date) => new Date(date.toLocaleString('en-US', { timeZone: PARIS }));

export const heureNotification = (iso) => {
  if (!iso) return '';
  const quand = new Date(iso);
  const maintenant = new Date();
  const minutes = Math.round((maintenant - quand) / 60000);
  if (minutes < 60) return `il y a ${Math.max(1, minutes)} min`;
  const h = quand.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', timeZone: PARIS });
  const jourQuand = aParis(quand);
  const jourNow = aParis(maintenant);
  const ecart = Math.floor((new Date(jourNow.getFullYear(), jourNow.getMonth(), jourNow.getDate())
    - new Date(jourQuand.getFullYear(), jourQuand.getMonth(), jourQuand.getDate())) / 86400000);
  if (ecart === 0) return h;
  if (ecart === 1) return `hier ${h}`;
  if (ecart < 7) return `${JOURS[jourQuand.getDay()]} ${h}`;
  return quand.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', timeZone: PARIS });
};

/** Groupe d'affichage : Aujourd'hui / Hier / Cette semaine / date. */
export const groupeJour = (iso) => {
  if (!iso) return '';
  const quand = aParis(new Date(iso));
  const now = aParis(new Date());
  const ecart = Math.floor((new Date(now.getFullYear(), now.getMonth(), now.getDate())
    - new Date(quand.getFullYear(), quand.getMonth(), quand.getDate())) / 86400000);
  if (ecart <= 0) return "Aujourd'hui";
  if (ecart === 1) return 'Hier';
  if (ecart < 7) return 'Cette semaine';
  return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric', timeZone: PARIS });
};

export const ICONES_TYPE = {
  demande: 'bi-envelope-paper',
  tache: 'bi-check2-square',
  visite: 'bi-door-open',
  diffusion: 'bi-broadcast',
  support: 'bi-life-preserver',
  incoherence: 'bi-exclamation-triangle',
};

export const LIBELLES_TYPE = {
  demande: 'Demandes',
  tache: 'Tâches',
  visite: 'Visites',
  diffusion: 'Diffusion',
  support: 'Support',
  incoherence: 'Incohérences',
};
